/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { authorStatisticsModelPagedResultSchema } from "./authorStatisticsModelPagedResultSchema.ts";
import { authorStatisticsModelSchema } from "./authorStatisticsModelSchema.ts";
import { z } from "zod";

export const authorsStatisticsModelSchema = z.object({
    "authors": z.lazy(() => authorStatisticsModelPagedResultSchema).and(z.object({
    "items": z.array(z.lazy(() => authorStatisticsModelSchema))
    })).describe("Авторы"),
"totalLikesCount": z.number().int().describe("Всего лайков"),
"totalDislikesCount": z.number().int().describe("Всего дизлайков"),
"totalTracksListensCount": z.number().int().describe("Всего прослушиваний треков (включений)"),
"totalTracksListens50Count": z.number().int().describe("Всего прослушиваний треков (>50%)"),
"totalTracksListens75Count": z.number().int().describe("Всего прослушиваний треков (>75%)"),
"totalTracksListens95Count": z.number().int().describe("Всего прослушиваний треков (>95%)"),
"totalTracksLikesCount": z.number().int().describe("Всего лайков треков"),
"totalTracksDislikesCount": z.number().int().describe("Всего дизлайков треков"),
"totalTracksSearchCount": z.number().int().describe("Всего поисков треков"),
"totalTracksSwapsCount": z.number().int().describe("Всего переключений треков"),
"totalTracksSharesCount": z.number().int().describe("Всего нажатий кнопки поделиться для треков"),
"totalTracksPlaylistsCount": z.number().int().describe("Всего добавлений в плейлист треков")
    })